import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';
import { IStructuredEssayQuestion, ISubQuestion, TQuestionDifficulty } from '.';

export interface IAdminCreateStructuredQuestion {
  subTopics?: Array<{ subTopic: string; paper: string }>;
  difficulty: TQuestionDifficulty;
  source?: string;
  tags?: string[];
  mainQuestion: string;
  totalMarks: number;
  subQuestions: Array<ISubQuestion>;
}

export interface IUpdateStructuredQuestion {
  id: string;
  subTopics: Array<{ subTopic: string; paper: string }>;
  difficulty: TQuestionDifficulty;
  source?: string;
  totalMarks: number;
  tags?: string[];
  mainQuestion: string;
  subQuestions: Array<ISubQuestion>;
}

export interface IApproveStructuredEssayQuestion {
  id: string;
  isApproved: boolean;
}

export interface ICreateStructuredEssayQuestion {
  questions: Array<IAdminCreateStructuredQuestion>;
}

const apiDataProvider = new APIDataProvider();

export const generateStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/generate',
  async (data: any) => {
    const response = await apiDataProvider.post<TApiResponse<any>>(
      `${AdminApiPaths.structuredEssayQuestions}/gptQuestion`,
      data
    );

    return response.data;
  }
);

export const adminCreateNewStructuredQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/create',
  async (data: ICreateStructuredEssayQuestion) => {
    const response = await apiDataProvider.post<
      TApiResponse<IStructuredEssayQuestion[]>
    >(`${AdminApiPaths.structuredEssayQuestions}/create`, data);

    return response.data;
  }
);

export const getStructuredEssayQuestionList = createAsyncThunk(
  'admin/structuredEssayQuestions/list',
  async (subTopic: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<IStructuredEssayQuestion[]>
    >(`${AdminApiPaths.structuredEssayQuestions}/list?subTopicId=${subTopic}`);

    return response.data;
  }
);

export const getStructuredEssayQuestionById = createAsyncThunk(
  'admin/structuredEssayQuestions/id',
  async (id: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<IStructuredEssayQuestion>
    >(`${AdminApiPaths.structuredEssayQuestions}/${id}`);

    return response.data;
  }
);

export const approveStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/approve',
  async (data: IApproveStructuredEssayQuestion) => {
    const response = await apiDataProvider.put<
      TApiResponse<IStructuredEssayQuestion>
    >(`${AdminApiPaths.structuredEssayQuestions}/approve/${data.id}`, data);

    return response.data;
  }
);

export const deleteStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/delete',
  async (data: { id: string }) => {
    const response = await apiDataProvider.put<
      TApiResponse<IStructuredEssayQuestion>
    >(`${AdminApiPaths.structuredEssayQuestions}/delete/${data.id}`, data);

    return response.data;
  }
);

export const updateStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/update',
  async (data: IUpdateStructuredQuestion) => {
    const { id, ...apiData } = data;
    const response = await apiDataProvider.put<
      TApiResponse<IStructuredEssayQuestion>
    >(`${AdminApiPaths.structuredEssayQuestions}/${id}`, apiData);

    return response.data;
  }
);
